import React from 'react'

import styled from 'styled-components'
import { LINKS } from '../../constants/links'
import Logo from '../../assets/logo-full-white.svg'

const FooterFrame = styled.footer`
  display: flex;
  opacity: 0.8;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  top: 0;
  padding: 20px;
  background: black;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: calc(100%);
    position: relative;
  `};
`
const FooterContainer = styled.div`
  background: black;
  border-radius: 0.75rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: flex-start;
  justify-content: space-around;
  -webkit-box-pack: start;
  width: 100%;
  padding: 5rem 8rem;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 12px;
    flex-direction: column;
`};

  .list {
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: auto;
`};
  }
`

const linkStyle = {
  color: 'white',
  textDecoration: 'underline',
  transition: 'color 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}

const hoverStyle = {
  color: '#4AFC38',
}
export default function Footer() {
  return (
    <>
      <FooterFrame>
        <FooterContainer>
          <div style={{ maxWidth: '600px' }}>
            <h1 style={{ fontSize: '14px', fontWeight: 500, color: 'white', marginTop: 0, fontFamily: 'unbounded' }}>
              <img src={Logo} alt="app logo" style={{ marginRight: '2px' }} /> HyperSwap{' '}
              <span style={{ fontSize: '8px', fontWeight: 300 }}>v{process.env.REACT_APP_VERSION}</span>
            </h1>
            <p style={{ color: 'white', fontSize: '14px', fontWeight: 400 }}>
              Redefining Decentralized Finance on HyperLiquid.
            </p>
            <div style={{ margin: '32px 0' }}>
              <span style={{ color: 'white', fontSize: '16px', fontWeight: 700 }}>Looking for assistance?</span>
              <p style={{ color: 'white', fontSize: '14px', fontWeight: 600 }}>
                Get dedicated support on{' '}
                <a href={LINKS['discord'].link} target="_blank" rel="noreferrer" style={{ fontWeight: 500 }}>
                  our official Discord
                </a>
                .
              </p>
            </div>
            <p style={{ fontSize: '10px' }}>&copy; {new Date().getFullYear()} HyperSwap Labs. All rights reserved.</p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }} className="list">
            <h2 style={{ fontSize: '14px', fontWeight: 500, color: 'white', margin: '0' }}>Socials</h2>
            <a
              id="link"
              href={LINKS['twitter'].link}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = hoverStyle.color)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {LINKS['twitter'].logo} {LINKS['twitter'].name}
            </a>
            <a
              id="link"
              href={LINKS['discord'].link}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = hoverStyle.color)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {LINKS['discord'].logo} {LINKS['discord'].name}
            </a>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }} className="list">
            <h2 style={{ fontSize: '14px', fontWeight: 500, color: 'white', margin: '0' }}>Resources</h2>
            <a
              id="link"
              href={LINKS['landingPage'].link}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = hoverStyle.color)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {LINKS['landingPage'].logo} {LINKS['landingPage'].name}
            </a>
            <a
              id="link"
              href={LINKS['github'].link}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = hoverStyle.color)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {LINKS['github'].logo} {LINKS['github'].name}
            </a>
            <a
              id="link"
              href={LINKS['docs'].link}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = hoverStyle.color)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {LINKS['docs'].logo} {LINKS['docs'].name}
            </a>
          </div>
        </FooterContainer>
      </FooterFrame>
    </>
  )
}
